import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'taxIdInput',
    'hint',
    'loader',
    'success',
    'failed',
    'hiddenForm',
    'hiddenTaxIdInput'
  ]

  clear() {
    if (this.hasSuccessTarget) {
      this.successTarget.classList.add("hidden");
    }

    if (this.hasFailedTarget) {
      this.failedTarget.classList.add("hidden");
    }

    if (this.hasHintTarget) {
      this.hintTarget.classList.remove("hidden");
    }
  }

  check() {
    if (!this.hasHiddenFormTarget) { return; }
    if (this.taxIdInputTarget.value == this.hiddenTaxIdInputTarget.value) { return; }

    this.clear();
    this.taxIdInputTarget.setAttribute("readonly", true);
    if (this.taxIdInputTarget.value && this.taxIdInputTarget.value.length) {
      if (this.hasHintTarget) {
        this.hintTarget.classList.add('hidden')
      }
      this.loaderTarget.classList.remove("hidden");
    }

    this.hiddenTaxIdInputTarget.value = this.taxIdInputTarget.value;
    this.hiddenFormTarget.requestSubmit();
  }
}
